import { render, staticRenderFns } from "./PeiHistory.vue?vue&type=template&id=5385b5b4&scoped=true&lang=true"
import script from "./PeiHistory.vue?vue&type=script&lang=js"
export * from "./PeiHistory.vue?vue&type=script&lang=js"
import style0 from "./PeiHistory.vue?vue&type=style&index=0&id=5385b5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385b5b4",
  null
  
)

export default component.exports